export const placeFragment = /* GraphQL */ `
  fragment placeData on Place {
    id
    name
    address
    city
    zipcode
    country
    type
    constructionYear
    surface
    description
    picture
    userID
    user {
      id
      name
    }
    location {
      lat
      lon
    }
    updatedAt
    organizationID
  }
`
